import { FetchStudents } from "api";
import { ClassIDState, ClassStudentsState, SchoolIDState } from "global-states";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

export function useClassInfo() {
	const schoolID = useRecoilValue(SchoolIDState);
	const classID = useRecoilValue(ClassIDState);
	const [students, setStudents] = useRecoilState(ClassStudentsState);
	const [error, setError] = useState("");
	useEffect(() => {
		if (schoolID === "" || classID === "") return;
		FetchStudents(classID)
			.then((res) => {
				setStudents(res.data || []);
			})
			.catch((err) => {
				setError(JSON.stringify(err));
			});
	}, [classID, schoolID, setStudents]);

	return {
		students,
		error,
	};
}
